import { useAuth } from '$features/auth/hooks/use-auth'
import { ReactNode } from 'react'
import { Navigate } from 'react-router'
import { RoutePath } from 'src/enums/routing'

export type UnprotectedOnlyProps = {
  children: ReactNode
}

export function UnprotectedOnly({ children }: UnprotectedOnlyProps) {
  const { isLoggedIn } = useAuth()

  return isLoggedIn ? <Navigate to={RoutePath.Root} /> : children
}
